<template>
    <div id="media-slide" v-if="!!selectedChat">
        <span class="material-icons media-btn" @click="() => $emit('close-media-slide')">arrow_back</span>
        <FilterTool
            id="media-slide-filtre"
            v-model="filters"
            :users="agents"
            v-if="selected === 'all'"
            :isGraphShowing="true"
            :keep-state-on-query-params="true"
        />
        <div class="media-type">
            <span class="type" :class="[filters.type === 'image' && 'selected-type']" @click="filterImages"
                >{{ $t("message.images") }}
            </span>
            <span class="type" :class="filters.type === 'file' && 'selected-type'" @click="filterFiles"
                >{{ $t("message.files") }}
            </span>
            <span class="type" :class="filters.type === 'url' && 'selected-type'" @click="filterURLs"
                >{{ $t("message.URLS") }}
            </span>
        </div>
        <div id="media-slide-area">
            <span
                v-if="messages.length > 0 && filters.type !== ' url '"
                v-for="message in getFilteredMessages()"
                :class="{ 'chat-media-assets': filters.type === 'file', 'chat-media-all': filters.type !== 'file' }"
            >
                <ImageMessage
                    v-if="message.type === 'image'"
                    :extended-style="extendedStyle()"
                    :message="message"
                    :message-colors="determineMessageColors()"
                />
                <AssetMessage
                    v-else-if="message.type === 'asset'"
                    :message="message"
                    :extended-style="extendedStyle()"
                    :message-colors="determineMessageColors()"
                    :is-filter-asset="filters.type === 'file'"
                />
            </span>
            <span v-if="urlMessages.length > 0 && filters.type === 'url'" id="url-message-wrapper">
                <LinkMessage v-for="(message, id) in getFilteredLinkMessages()" :message="message" :key="id" />
            </span>
        </div>
        <NoMessage
            v-if="!getFilteredMessages().length && !getFilteredLinkMessages().length"
            :title="$t('message.noMediaToShow')"
            :isGraphShowing="true"
            :keep-state-on-query-params="true"
        />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import Avatar from "vue-avatar";
import * as _ from "lodash";
import { toNewMessagesModel } from "../../../utils/chat";
import ImageMessage from "../../../components/popup-chat/messages/ImageMessage";
import AssetMessage from "../../../components/popup-chat/messages/AssetMessage";
import LinkMessage from "../../../components/popup-chat/messages/LinkMessage";
import NoMessage from "./NoMessage.vue";
import FilterTool from "../Chatbot/pages/archive/FilterTool.vue";
import moment from "moment";
import TimeUtils from "../../../utils/TimeUtils";

const log = log2("MediaSlide");

export default {
    name: "MediaSlide",
    components: { Avatar, ImageMessage, AssetMessage, NoMessage, FilterTool, LinkMessage },
    props: {},
    data() {
        return {
            messages: [],
            urlMessages: [],
            links: [],
            colors: {
                header: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                launcher: {
                    bg: "#4e8cff",
                },
                messageList: {
                    bg: "#ffffff",
                },
                sentMessage: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                receivedMessage: {
                    bg: "#eaeaea",
                    text: "#222222",
                },
                userInput: {
                    bg: "#f4f7f9",
                    text: "#565867",
                },
            },
            selected: "all",
            filters: {
                period: this.$route.query.period || "",
                userIds: this.$route.query.userIds ? this.$route.query.userIds.split(",") : null,
                type: "image", // image | file | URL
            },
            agents: [],
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            selectedChat: (state) => state.team.selectedChat,
            chats: (state) => state.team.chats,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({
            getUser: "user/getUser",
        }),
        randomBgColorWithName() {
            return this.site.randomBgColorWithName;
        },
    },

    methods: {
        ...mapActions({
            getChatMedia: "team/getChatMedia",
            extractLinksFromChat: "team/extractLinksFromChat",
        }),
        /*isMessageURL(message) {
            const urlRegex = /(?:(https?:\/\/|www\.)\S+\.\S+)|(?:\b\w+\.\w+\b)/g;
            return urlRegex.test(message);
        },*/
        filterImages() {
            this.filters.type = "image";
        },
        filterFiles() {
            this.filters.type = "file";
        },
        filterURLs() {
            this.filters.type = "url";
        },
        extendedStyle() {
            return {
                width: "auto",
                /*minWidth: "125px",*/
            };
        },

        determineMessageColors() {
            const me = true;
            const isPM = this.messages.raw && this.messages.raw.messageType === "private";

            return isPM ? this.privateColorsStyle() : me ? this.sentColorsStyle() : this.receivedColorsStyle();
        },

        privateColorsStyle() {
            return {
                color: this.colors.receivedMessage.text,
                backgroundColor: "rgb(253 255 104)",
                opacity: "0.5",
            };
        },

        sentColorsStyle() {
            return {
                color: this.colors.sentMessage.text,
                backgroundColor: this.randomBgColorWithName
                    ? this.randomColorFromName(this.messages.senderName)
                    : this.colors.sentMessage.bg,
            };
        },

        randomColorFromName(name = "") {
            let hash = 0;
            if (name.length === 0) return hash;
            for (let i = 0; i < name.length; i++) {
                hash = name.charCodeAt(i) + ((hash << 5) - hash);
                hash = hash & hash;
            }

            let rgb = [0, 0, 0];
            for (let i = 0; i < 3; i++) {
                rgb[i] = (hash >> (i * 4)) & 255;
            }
            return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]},1)`;
        },

        receivedColorsStyle() {
            return {
                color: this.colors.receivedMessage.text,
                backgroundColor: this.colors.receivedMessage.bg,
            };
        },
        getFilteredLinkMessages() {
            /*console.log("messagessss", {messagesContent: this.urlMessages.map((message) => message)})*/
            return this.urlMessages
                .filter((message) => {
                    if (this.filters.period === "") {
                        return true;
                    } else {
                        const { endTS, startTS } = TimeUtils.calculatePeriod(
                            this.filters.period,
                            this.filters.startDate,
                            this.filters.endDate
                        );
                        return moment(message.createdDate).isBetween(startTS, endTS);
                    }
                })
                .filter((message) => {
                    if (this.filters.userIds === null) {
                        return true;
                    } else {
                        return this.filters.userIds.includes(message.raw.user._id);
                    }
                });
        },
        getFilteredMessages() {
            /*console.log("messagessss", {messagesContent: this.messages.map((message) => message.data.text)})*/
            return this.messages
                .filter((message) => {
                    /*console.log("contenssss", message.data.text)*/
                    if (this.filters.type === "image") {
                        return message.type === "image";
                    } else if (this.filters.type === "file") {
                        return message.type === "asset";
                    } else if (this.filters.type === "url") {
                        return message.type === "text";
                    }
                })
                .filter((message) => {
                    if (this.filters.period === "") {
                        return true;
                    } else {
                        const { endTS, startTS } = TimeUtils.calculatePeriod(
                            this.filters.period,
                            this.filters.startDate,
                            this.filters.endDate
                        );
                        return moment(message.createdDate).isBetween(startTS, endTS);
                    }
                })
                .filter((message) => {
                    if (this.filters.userIds === null) {
                        return true;
                    } else {
                        return this.filters.userIds.includes(message.raw.user._id);
                    }
                });
        },
    },
    async mounted() {
        const selectedChatMeta = this.selectedChat.meta;
        this.agents = ["team", "department"].includes(selectedChatMeta.chatType)
            ? this.users
            : selectedChatMeta.chatType == "thread"
            ? [selectedChatMeta.thread.agent1, selectedChatMeta.thread.agent2]
            : selectedChatMeta.groupThread.agents;
        const result = await this.getChatMedia(this.selectedChat._id);
        const msgs = _.uniqBy(_.sortBy(result, "createdDate"), "uniqMessageId");
        this.messages = toNewMessagesModel(msgs, this, false, true, _.get(this.user, "_id"));
        this.extractLinksFromChat(this.selectedChat._id).then((res) => {
            this.urlMessages = res.reduce((acc, message) => {
                const description = message.description;

                const urlRegex = /(?:(https?:\/\/|www\.)\S+\.\S+)|(?:\b\w+\.\w+\b)/g;

                const urls = description.match(urlRegex);

                acc.push(
                    ...urls.map((url) => ({
                        ...message,
                        description: url.replace(/[(<p>|<p\/>)]/g, ""),
                    }))
                );
                return acc;
            }, []);
            this.urlMessages = _.sortBy(this.urlMessages, "createdDate").reverse();
        });
    },
};
</script>

<style lang="scss">
#media-slide {
    margin-left: 10px;

    .media-btn {
        color: #9f8524;
        font-size: 25px;
        font-weight: bolder;
        cursor: pointer;
        padding: 10px;
    }

    .media-type {
        margin: 10px 10px 10px;
        display: flex;
        justify-content: space-between;
        border-radius: 5px;
        background-color: #f2f2f2;

        .type {
            display: flex;
            justify-content: center;
            align-items: center;
            min-width: 30%;
            padding: 8px;
            color: black;
            cursor: pointer;
        }

        .selected-type {
            border-radius: 5px;
            font-weight: 600;
            background: #ec4a1d;
            color: white;
        }
    }

    #media-slide-area {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        max-width: 100% !important;

        #url-message-wrapper {
            width: 95% !important;
            padding: 5px !important;
            /*background-color: #F2F2F2;*/
            #LinkMessageSlot {
                display: flex;
                flex-direction: column;
                margin-top: 5px;
                height: max-content;
                width: 100%;
                background-color: #f2f2f2;
                border-radius: 5px;
                padding-top: 6px;

                #time-area {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: flex-end;
                    font-size: xx-small;
                    color: black;
                    margin-right: 5px;

                    p {
                        margin: 0;
                    }
                }

                #link-area {
                    display: flex;
                    justify-content: center;
                    height: 20px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-align: center;

                    p {
                        color: cornflowerblue;
                        display: inline-block;
                        height: max-content;
                        text-decoration: underline;
                        cursor: pointer;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        width: 70%;
                    }
                }
            }
        }

        .chat-media-all {
            width: 100px !important;
            height: 75px !important;
            max-height: 75px !important;
            position: relative;

            img {
                width: 100px !important;
                max-width: 100% !important;
                height: 75px !important;
                max-height: 75px !important;
            }

            #assetMessage {
                background-color: #f2f2f2 !important;
                width: 94px !important;
                max-width: 94px !important;
                height: 69px !important;
                max-height: 75px !important;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                min-width: 100% !important;
                max-height: 50px !important;
                display: flex;
                background: transparent !important;
            }

            .fi {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }

        .chat-media-assets {
            width: 95% !important;
            padding: 5px !important;
            background-color: #f2f2f2;
            border-bottom: 1px solid gray !important;

            #assetMessage {
                min-width: 100% !important;
                max-height: 50px !important;
                display: flex;
                background: transparent !important;
            }

            .sc-message--meta {
                right: 5px;
                color: black;
            }
        }
    }
}

#media-slide-filtre {
    .filters {
        .filter-wrapper-preview {
            max-width: 100px !important;
            background: #9f8524 !important;
        }
    }
}
</style>
